/**
 * По умолчанию пункт меню отображается.
 *
 * @kind helper
 */
export const useAlwaysShow = () => true;

/**
 * По умолчанию у пункта меню нет точки-уведомления.
 *
 * @kind helper
 */
export const useNeverNotify = () => false;
